import React from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Typography } from '@material-ui/core';
import LockTwoTone from '@material-ui/icons/LockTwoTone';
import { actions } from '../../../actions/boardActions';
import { actions as authActions } from '../../../actions/authActions';
import { actions as surveyActions } from '../../../actions/publicSurveyActions';
import LoadingIndicator from '../../LoadingIndicator';
import BoardThreadDetails from './BoardThreadDetails';
import UserInfoPanel from '../../auth/UserInfoPanel';
import routePaths from '../../../routePaths';
import { ParticipantVerificationStatus } from '../../../models/auth/ParticipantVerificationStatus';
import { ParticipantOrganizationTypes } from '../../../models/auth/ParticipantOrganizationTypes';

const DEFAULT_PAGE_SIZE = 50;

class BoardThreadPage extends React.Component {
  state = {
    submitting: false,
  };

  componentDidMount() {
    this.props.surveyActions.getDetails(this.props.match.params.id);
    this.props.actions.getPosts(this.props.match.params.id, this.props.match.params.threadId, DEFAULT_PAGE_SIZE, 0);
  }

  loadNext = () => this.props.actions.getNextPosts(this.props.match.params.id, this.props.match.params.threadId, DEFAULT_PAGE_SIZE, this.props.thread.posts.length - 1);

  executeAction = action => {
    this.setState({ submitting: true});
    return action().finally(() => this.setState({ submitting: false }));
  }

  validatePariticipationConstraints(organizationType) {
    if (!this.props.survey.participationConstraints.requireCompany && !this.props.survey.participationConstraints.requireNonGovernmentOrganization && !this.props.survey.participationConstraints.requireSubordinateOrganization) return true;

    let isValid = false;
    if (this.props.survey.participationConstraints.requireCompany && organizationType === ParticipantOrganizationTypes.company) isValid = true;
    if (this.props.survey.participationConstraints.requireNonGovernmentOrganization && organizationType === ParticipantOrganizationTypes.nonGovernment) isValid = true;
    if (this.props.survey.participationConstraints.requireSubordinateOrganization && organizationType === ParticipantOrganizationTypes.subordinate) isValid = true;
    
    return isValid;
  }

  render() {
    const { fetching, thread, auth, survey, account } = this.props;
    const { submitting } = this.state;
    
    const satisfyingParticipationConstraints = survey != null
      && (!survey.participationConstraints.requireVerification || (account && account.verificationStatus === ParticipantVerificationStatus.verified))
      && (account && this.validatePariticipationConstraints(account.organizationType));

    return (
      <div style={{ padding: 16 }}>
        <LoadingIndicator fetching={fetching}>
          {thread && survey ?
            <React.Fragment>
              <div className="row top">
                <div className="col-sm-2" />
                <div className="col-sm-3" />
                <div className="col-sm-7 header">
                  <UserInfoPanel auth={this.props.auth} authenticationRequired={survey.authenticationRequired} authActions={this.props.authActions} account={this.props.account} />
                  <a href={`${routePaths.consultations}${this.props.match.params.id}`} className="btn"><i className="fa fa-long-arrow-alt-left" /> powrót do konsultacji</a>
                </div>
              </div>
              <div>
                {thread.pendingApproval && <Typography variant="caption" style={{ marginTop: 10 }} color="textSecondary">Oczekuje na akceptację</Typography>}
                {thread.closed ? 
                  <div style={{ marginTop: 10, display: 'flex', alignContent: 'center' }}>
                    <LockTwoTone titleAccess="Zamknięty" fontSize="small" style={{ marginRight: 4 }} /> <Typography color="textPrimary" component="p">{thread.boardSettings.readonly ? 'Forum działa w trybie tylko do odczytu' : 'Wątek został zamknięty'}</Typography>
                  </div>
                  : null}
              </div>
              <div style={{ marginTop: 10 }}>
                <div className="row">
                  <div className="box">
                    <div className="col-sm-12">
                      <BoardThreadDetails
                        thread={thread}
                        onLoadNext={this.loadNext}
                        onAddPost={data => this.executeAction(() => this.props.actions.addPost(this.props.match.params.id, this.props.match.params.threadId, data))}
                        onReact={(post, reaction) => this.executeAction(() => this.props.actions.addReaction(this.props.match.params.id, this.props.match.params.threadId, post.id, reaction))}
                        onUndoReact={(post, reaction) => this.executeAction(() => this.props.actions.undoReaction(this.props.match.params.id, this.props.match.params.threadId, post.id, reaction))}
                        submitting={submitting}
                        signedIn={auth.signedIn}
                        satisfyingParticipationConstraints={satisfyingParticipationConstraints}
                        authenticationRequired={survey.authenticationRequired}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </React.Fragment> : null}
        </LoadingIndicator>
      </div>
    );
  }
}

BoardThreadPage.propTypes = {
  t: PropTypes.func.isRequired,
  actions: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  fetching: PropTypes.bool.isRequired,
  thread: PropTypes.object,
  auth: PropTypes.object.isRequired,
  account: PropTypes.object,
  authActions: PropTypes.object.isRequired,
  surveyActions: PropTypes.object.isRequired,
  survey: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    fetching: state.publicSurveyDetails.fetching || state.boardThreadDetails.fetching,
    thread: state.boardThreadDetails.data,
    survey: state.publicSurveyDetails.data,
    auth: state.auth,
    account: state.account.data,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
    authActions: bindActionCreators(authActions, dispatch),
    surveyActions: bindActionCreators(surveyActions, dispatch),
  };
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  translate()
)(BoardThreadPage);



// WEBPACK FOOTER //
// ./src/components/consultationSurveys/board/BoardThreadPage.js